import { createStyles } from 'antd-style'

import {
  EDITOR_CONTENT_HORIZONTAL_PADDING,
  EDITOR_TOOLBAR_HEIGHT
} from './constants'

export const useEditorStyles = createStyles(({ token }) => ({
  editor: {
    position: 'relative',
    display: 'block',
    width: '100%',
    backgroundColor: token.colorWhite,
    borderBottomLeftRadius: token.borderRadiusLG,
    borderBottomRightRadius: token.borderRadiusLG,
    [`& ::selection`]: {
      backgroundColor: token.colorPrimaryBgHover
    },
    [`&.is-bordered`]: {
      border: `1px solid ${token.colorBorderSecondary}`
    }
  },
  toolbar: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    height: EDITOR_TOOLBAR_HEIGHT,
    paddingInline: `${EDITOR_CONTENT_HORIZONTAL_PADDING}px`,
    borderBottom: `1px solid ${token.colorBorderSecondary}`,
    background: token.colorWhite,
    [`& .anticon`]: {
      fontSize: token.fontSizeLG
    }
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    contain: 'layout style'
  },
  main: {
    position: 'relative',
    minHeight: 150,
    flex: 1,
    overflow: 'hidden'
  },
  content: {
    position: 'relative',
    display: 'block',
    minHeight: '100%',
    padding: `${token.paddingXS}px ${EDITOR_CONTENT_HORIZONTAL_PADDING}px ${token.padding}px ${EDITOR_CONTENT_HORIZONTAL_PADDING}px`,
    outline: 0,
    border: 0,
    [`&.is-preview`]: {
      padding: 0
    }
  },
  placeholder: {
    position: 'absolute',
    top: 8,
    left: EDITOR_CONTENT_HORIZONTAL_PADDING,
    right: EDITOR_CONTENT_HORIZONTAL_PADDING,
    zIndex: -1,
    display: 'inline-block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: token.colorTextQuaternary,
    fontSize: token.fontSize,
    userSelect: 'none',
    pointerEvents: 'none'
  },
  siderbar: {
    flex: 'none'
  },
  tableOfContnets: {
    position: 'sticky',
    marginInlineStart: token.marginXL
  }
}))
